/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { CreateReservationCreditPurchasePayload } from 'api/actions/create-reservation-credit-purchase/create-reservation-credit-purchase-payload';
import { CreateReservationCreditPurchasePathParameters } from 'api/actions/create-reservation-credit-purchase/create-reservation-credit-purchase-path-parameters';
import { CreateReservationCreditPurchaseResponse } from 'api/actions/create-reservation-credit-purchase/create-reservation-credit-purchase-response';

type CreateReservationCreditPurchaseQueryParameters = Record<string, any>;

/**
 * The path of the CreateReservationCreditPurchase action.
 */
export const createReservationCreditPurchaseActionPath = new SweetPath<
  keyof CreateReservationCreditPurchasePathParameters
>('/reservations/credits/purchases', { path: '{param}' });

/**
 * Creates a contextualized CreateReservationCreditPurchase actions.
 */
export default function createCreateReservationCreditPurchaseAction(axios: AxiosInstance) {
  return function createReservationCreditPurchaseAction({
    headers = {},
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    query?: CreateReservationCreditPurchaseQueryParameters;
    payload: CreateReservationCreditPurchasePayload;
  }) {
    const path = createReservationCreditPurchaseActionPath.original;

    return axios.post<
      CreateReservationCreditPurchaseResponse,
      CreateReservationCreditPurchaseResponse,
      CreateReservationCreditPurchasePayload
    >(path, payload);
  };
}
